const settings = {
    AL: {
        labelPosition: {
            bottom: '27%',
            left: '65.75%',
        },
        zoomParameters: {
            desktop: {
                scale: 4,
                xPercent: -85,
                yPercent: -130,
            },
            mobile: {
                scale: 7,
                xPercent: -160,
                yPercent: -195,
            },
        },
    },
    FL: {
        labelPosition: {
            bottom: '10%',
            left: '74.5%',
        },
        zoomParameters: {
            desktop: {
                scale: 3.5,
                xPercent: -98,
                yPercent: -183,
            },
            mobile: {
                scale: 6,
                xPercent: -180,
                yPercent: -275,
            },
        },
    },
    GA: {
        labelPosition: {
            bottom: '26%',
            left: '71.5%',
        },
        zoomParameters: {
            desktop: {
                scale: 4,
                xPercent: -110,
                yPercent: -130,
            },
            mobile: {
                scale: 6.5,
                xPercent: -185,
                yPercent: -183,
            },
        },
    },
    KY: {
        labelPosition: {
            bottom: '46%',
            left: '69%',
        },
        zoomParameters: {
            desktop: {
                scale: 3.65,
                xPercent: -88.5,
                yPercent: -63,
            },
            mobile: {
                scale: 6.75,
                xPercent: -167,
                yPercent: -65,
            },
        },
    },
    NC: {
        labelPosition: {
            bottom: '38%',
            left: '79%',
        },
        zoomParameters: {
            desktop: {
                scale: 3.25,
                xPercent: -115,
                yPercent: -90,
            },
            mobile: {
                scale: 6.25,
                xPercent: -220,
                yPercent: -115,
            },
        },
    },
    OK: {
        labelPosition: {
            bottom: '38%',
            left: '47.5%',
        },
        zoomParameters: {
            desktop: {
                scale: 2.8,
                xPercent: -12,
                yPercent: -82,
            },
            mobile: {
                scale: 5.75,
                xPercent: -21,
                yPercent: -110,
            },
        },
    },
    SC: {
        labelPosition: {
            bottom: '31%',
            left: '76%',
        },
        zoomParameters: {
            desktop: {
                scale: 5.5,
                xPercent: -168,
                yPercent: -141,
            },
            mobile: {
                scale: 7.75,
                xPercent: -248,
                yPercent: -177,
            },
        },
    },
    TN: {
        labelPosition: {
            bottom: '38.75%',
            left: '66%',
        },
        zoomParameters: {
            desktop: {
                scale: 4.15,
                xPercent: -102,
                yPercent: -90,
            },
            mobile: {
                scale: 6.5,
                xPercent: -161,
                yPercent: -105,
            },
        },
    },
    TX: {
        labelPosition: {
            bottom: '22%',
            left: '45%',
        },
        zoomParameters: {
            desktop: {
                scale: 2,
                xPercent: -12,
                yPercent: -100,
            },
            mobile: {
                scale: 3.75,
                xPercent: -30,
                yPercent: -155,
            },
        },
    },
};

export default settings;
